import ApiService from "./ApiService";
import AuthService from "./AuthService";

export default class ReportApiService extends AuthService {
  constructor(autoDeserialize = true, service = new ApiService(false)) {
    service._url = path => {
      return (process.env.REPORT_API_URL || process.env.API_URL) + path;
    };
    super(autoDeserialize, service);
  }
}
